import LoginWithOtp from "@/app/(pages)/(prelogin)/workflow/login-with-otp";
import { Config, LoginFlow } from "@thriwe-2-0/thriwe-ui-utils";
import { RefObject } from "react";
import LoginWithOtpV2 from "./login-with-otp-v2";
import LoginWithPasswordV2 from "./login-with-password-v2";

export function renderLoginComponentV2(config: Config | undefined) {
  const loginConfig = config?.login;

  switch (loginConfig?.loginFlow) {
    case LoginFlow.LOGIN_WITH_MOBILE_EMAIL_OTP:
      if (config?.designVersion == "v2") {
        return <LoginWithOtpV2 />;
      } else
        return (
          <LoginWithOtp
            termsAndCondition={config?.login?.termAndConditionCheckbox}
            islogin={true}
          />
        );
    case LoginFlow.LOGIN_REGISTER_WITH_MOBILE_OTP:
      return (
        <LoginWithOtp
          termsAndCondition={config?.login?.termAndConditionCheckbox}
          islogin={true}
        />
      );

    case LoginFlow.LOGIN_WITH_MOBILE_EMAIL_PASSWORD:
      return <LoginWithPasswordV2 />;
  }
}
export const handleKeyDown = (
  e: React.KeyboardEvent,
  buttonRef: RefObject<HTMLElement>
) => {
  if (e.key === "Enter" && buttonRef.current) {
    console.log("enterenter");
    buttonRef?.current?.click();
  }
};
export const switchProviderId = (ProviderId: string) => {
  switch (ProviderId) {
    case "google.com":
      return "google";
    case "facebook.com":
      return "facebook";
    case "apple.com":
      return "apple";
  }
};
